// File: frontend/src/pages/Socrates/components/AIAgentsAdmin/AgentArtifacts/index.js

import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCog, faPlus, faSearch, 
  faDownload, faEdit, faTrash 
} from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import SocratesCard from '../../common/SocratesCard';
import styles from './AgentArtifacts.module.css';

const AgentArtifacts = ({ agent }) => {
  const { t } = useLanguage();
  const [searchTerm, setSearchTerm] = useState('');

  // Mock artifacts data
  const mockArtifacts = [
    {
      id: 'artifact_1',
      name: 'Customer Response Template',
      type: 'template',
      size: '2.4 KB',
      lastModified: '2024-01-20T14:30:00Z',
      status: 'active'
    },
    {
      id: 'artifact_2',
      name: 'Error Handling Script',
      type: 'script',
      size: '5.1 KB',
      lastModified: '2024-01-19T10:15:00Z',
      status: 'active'
    },
    {
      id: 'artifact_3',
      name: 'Data Processing Config',
      type: 'config',
      size: '1.8 KB',
      lastModified: '2024-01-18T16:45:00Z',
      status: 'inactive'
    }
  ];

  const filteredArtifacts = mockArtifacts.filter(artifact =>
    artifact.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    artifact.type.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <div className={styles.agentArtifacts}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <h2 className={styles.title}>
            <FontAwesomeIcon icon={faCog} className={styles.titleIcon} />
            {t('artifacts')}
          </h2>
          <p className={styles.subtitle}>
            {t('manage_artifacts_for', { agentName: agent.display_name })}
          </p>
        </div>
        <div className={styles.headerRight}>
          <button className={styles.createButton}>
            <FontAwesomeIcon icon={faPlus} />
            <span>{t('add_artifact')}</span>
          </button>
        </div>
      </div>

      <div className={styles.controls}>
        <div className={styles.searchContainer}>
          <FontAwesomeIcon icon={faSearch} className={styles.searchIcon} />
          <input
            type="text"
            placeholder={t('search_artifacts')}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className={styles.searchInput}
          />
        </div>
      </div>

      <SocratesCard className={styles.artifactsCard}>
        <div className={styles.cardContent}>
          {filteredArtifacts.length === 0 ? (
            <div className={styles.emptyState}>
              <FontAwesomeIcon icon={faCog} className={styles.emptyIcon} />
              <h3>{t('no_artifacts_found')}</h3>
              <p>{t('no_artifacts_description')}</p>
              <button className={styles.createFirstButton}>
                <FontAwesomeIcon icon={faPlus} />
                {t('create_first_artifact')}
              </button>
            </div>
          ) : (
            <div className={styles.artifactsList}>
              {filteredArtifacts.map((artifact) => (
                <div key={artifact.id} className={styles.artifactItem}>
                  <div className={styles.artifactInfo}>
                    <div className={styles.artifactHeader}>
                      <h4 className={styles.artifactName}>{artifact.name}</h4>
                      <div className={`${styles.statusBadge} ${styles[artifact.status]}`}>
                        {t(artifact.status)}
                      </div>
                    </div>
                    <div className={styles.artifactMeta}>
                      <span className={styles.artifactType}>{artifact.type}</span>
                      <span className={styles.artifactSize}>{artifact.size}</span>
                      <span className={styles.artifactDate}>
                        {t('modified')}: {formatDate(artifact.lastModified)}
                      </span>
                    </div>
                  </div>
                  <div className={styles.artifactActions}>
                    <button className={styles.actionButton} title={t('download')}>
                      <FontAwesomeIcon icon={faDownload} />
                    </button>
                    <button className={styles.actionButton} title={t('edit')}>
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    <button className={styles.actionButton} title={t('delete')}>
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </SocratesCard>
    </div>
  );
};

export default AgentArtifacts;